import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Button } from '@heroui/react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

type ImportHistoryAlertProps = {
    /**
     * `load`: no history could be read, in place of the table. `refresh`: a
     * later read failed, above the table it left on screen.
     */
    kind: 'load' | 'refresh';
    onRetry: () => void;
};

/** A failed read of the history, with Try again. */
export const ImportHistoryAlert: React.FC<ImportHistoryAlertProps> = ({
    kind,
    onRetry,
}) => {
    const { t } = useTranslation('pages');

    return (
        <Alert
            status={kind === 'load' ? 'danger' : 'warning'}
            {...getNodeTestIdProp(`branch-import-history-${kind}-error`)}
        >
            <Alert.Indicator />
            <Alert.Content>
                <Alert.Title>
                    {kind === 'load'
                        ? t('catalogImport.branchImport.history.loadError')
                        : t('catalogImport.branchImport.history.refreshError')}
                </Alert.Title>
                <div className="pt-2">
                    <Button
                        onPress={onRetry}
                        size="sm"
                        variant="secondary"
                        {...getNodeTestIdProp(
                            `branch-import-history-${kind}-retry`,
                        )}
                    >
                        {t('catalogImport.branchImport.history.retry')}
                    </Button>
                </div>
            </Alert.Content>
        </Alert>
    );
};
